import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const InviteUsersPopup = loadAsyncComponent(() => import('./Container'), 'popup');
